import { graphql } from "api/cms-website/generated";

export const BannerPaidSocialFragment = graphql(/* GraphQL */ `
    fragment BannerPaidSocialFragment on ComponentComponentsBannerPaidSocial {
        id
        noMarginBottom
        bannerPaidSocialTitle: title
        bannerPaidSocialText: text
        badge
        bannerPaidSocialCta: cta {
            ...ButtonFragment
        }
        image {
            ...ResponsiveImageFragment
        }
        bannerPaidSocialAdvantages: advantages {
            ...MainBannerAdvantageFragment
        }
        showInvisalignLogo
    }
`);
